import { query } from '@confluence/query-preloader-tools';
import { getOnboardingStateGQL } from '@confluence/onboarding-helpers/entry-points/getOnboardingStateGQL';

import {
	CREATE_INTRO_FIRST_STEP_ONBOARDING_STATE_KEYS,
	ONBOARDING_EXPERIENCES,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export const preloadCreateIntroFirstStepOnboardingState = () => {
	return query({
		query: getOnboardingStateGQL,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(CREATE_INTRO_FIRST_STEP_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
